import { store } from "../../../../../config/redux.storage";
import { decrypt } from "./code";
import { googleEvents } from "../../../../../utils/googleEvents";
import { translate } from "../../../../../api/utils/i18nHelper";

export function setNestedProperty(obj, propertyPath, newValue) {
  const properties = propertyPath.split('.').filter(property => property !== '');
  let currentObj = obj;

  for (let i = 0; i < properties.length; i++) {
    if (properties[i] !== '' && currentObj[properties[i]] !== undefined) {
      if (i === properties.length - 1) {
        currentObj[properties[i]] = { ...currentObj[properties[i]], ...newValue };
      } else {
        currentObj = currentObj[properties[i]];
      }
    } else if (currentObj[properties[i]] === undefined) {
      currentObj[properties[i]] = { ...newValue };
    } else if (properties[i] !== '') {
      return undefined;
    }
  }
}

export function removeNestedProperty(obj, propertyPath, propertyToRemove) {
  const properties = propertyPath.split('.');
  let currentObj = obj;

  for (let i = 0; i < properties.length - 1; i++) {
    if (!currentObj || currentObj[properties[i]] === undefined) {
      return; // Stop if any part of the property path is undefined or null
    }
    currentObj = currentObj[properties[i]];
  }

  if (currentObj && currentObj.hasOwnProperty(properties[properties.length - 1])) {
    delete currentObj[properties[properties.length - 1]][propertyToRemove];
  }
}

export const scrollToElement = (selector) => {
  setTimeout(() => {
    const element = document.querySelector(selector);
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: elementTop, behavior: 'smooth' });
    }
  }, 500);
};

function getNestedProperty(obj, propertyPath) {
  const properties = propertyPath.split('.');
  let currentObj = obj;

  for (let i = 0; i < properties.length; i++) {
    if (properties[i] !== '' && currentObj[properties[i]] !== undefined) {
      currentObj = currentObj[properties[i]];
    } else if (properties[i] !== '') {
      return undefined;
    }
  }

  return currentObj;
}


const createJson = (key, value) => {
  return !!key ? JSON.stringify({ [key.split(".").pop()]: value }) : JSON.stringify(value);
}

const getEncryptedValue = async (value) => {
  const { fieldEncryptionEndpointPath } = store.getState().myPuratos_account.signUpModel;

  try {
    const response = await fetch(`${fieldEncryptionEndpointPath}?fieldValue=${encodeURIComponent(value)}`);
    if (response.ok) {
      const data = await response.json();
      const { encryptedFieldValue } = data;
      return encryptedFieldValue;
    } else {
      console.error('Password encryption API failed', response.statusText);
      return value;
    }
  } catch (error) {
    console.error(error);
    return value;
  }
}
const validateFieldValue = async (value, validationType, key = '', newCustomer = true) => {
  const { fieldValidationEndpointPath, formLocale } = store.getState().myPuratos_account.signUpModel;
  const {i18n} = store.getState().myPuratos_i18n;
  const isPassword = key.toLowerCase().includes('password');
  const fieldValue = isPassword ? await getEncryptedValue(value) : value;

  if (isPassword && fieldValue === value) {
    console.error("Password encryption API failed")
    return { status: 500, data: { Errors: [translate(i18n, 'General error') || 'General error'] }, key };
  }

  if (!fieldValidationEndpointPath) {
    return null;
  }

  try {
    const response = await fetch(`${fieldValidationEndpointPath}?locale=${formLocale}&validationType=${validationType}&fieldValue=${createJson(key, fieldValue)}`);

    if (response.status === 200 && newCustomer) {
      return { status: 200, data: {}, key };
    }

    const data = await response.json();
    return { status: response.status, data, key };
  } catch (error) {
    console.error(error);
    return { status: 500, data: { Errors: [translate(i18n, 'General error') || 'General error'] }, key };
  }
};

const complexValidateWithApi = async (formData, fieldsForApiValidation) => {
  const fields = fieldsForApiValidation.map(({ key, validationType, isSimple }) => {
    return isSimple ? null : {
      value: { [key]: getNestedProperty(formData, key) },
      type: validationType
    }
  }).filter(field => !!field);

  if (fields.length === 0) {
    return false;
  }

  const groupedFields = fields.reduce((grouped, field) => {
    const key = field.type;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(field);
    return grouped;
  }, {});

  const fieldsToValidate = [];
  const validationAPITypes = Object.keys(groupedFields);

  validationAPITypes.forEach(type => {
    let fieldValue = {};
    groupedFields[type].forEach(({ value }) => fieldValue = { ...fieldValue, ...value })
    fieldsToValidate.push({
      value: fieldValue,
      validationType: type,
    })
  })

  const validationPromises = fieldsToValidate.map(({
                                                     value,
                                                     validationType,
                                                   }) => validateFieldValue(value, validationType, '', false));

  try {
    const validationResults = await Promise.all(validationPromises);
    return validationResults[0].data.hasContact;
  } catch (error) {
    console.error(error);
    return false;
  }
};
const validateWithAPI = async ({
                                 validatedData,
                                 setValidatedData,
                                 formData,
                                 errors,
                                 updatedUiSchema,
                                 fieldsForApiValidation
                               }) => {
  if (fieldsForApiValidation.length === 0) {
    return true;
  }

  const fieldsToValidate =
    fieldsForApiValidation
      .filter(({ key }) => {
        return !errors.some(({ property }) => property?.includes(key)) && getNestedProperty(formData, key) !== undefined && getNestedProperty(formData, key) !== '';
      })
      .filter(({ key }) => validatedData[key] !== getNestedProperty(formData, key));

  const validationPromises = fieldsToValidate.map(({
                                                     key,
                                                     validationType
                                                   }) => validateFieldValue(getNestedProperty(formData, key), validationType, key));

  try {
    const validationResults = await Promise.all(validationPromises);
    return await handleValidationStatus(validationResults, updatedUiSchema, validatedData, setValidatedData, formData);
  } catch (error) {
    console.error(error);
    return false;
  }
};

const handleValidationStatus = async (responses, updatedUiSchema, validatedData, setValidatedData, formData) => {
  let updatedValidatedData = {};
  let allValid = [];

  responses.forEach(({ status, data, key }) => {
    if (!status) {
      allValid.push(false)
    }
    if (status === 200) {
      updatedValidatedData[key] = getNestedProperty(formData, key);
      allValid.push(true);
    } else {
      setNestedProperty(updatedUiSchema, key, {
        'classNames': 'has-error',
        'ui:apiError': data.Errors[0],
      });
      allValid.push(false);
    }
  });

  setValidatedData({ ...validatedData, ...updatedValidatedData });
  return allValid.every(valid => valid);
};

function filterFalsyValues(obj) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      const filteredValue = filterFalsyValues(value);
      acc[key] = filteredValue;
    } else if (value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
}

const findPropertyPath = (obj, keyToFind, path = '') => {
  for (const [key, value] of Object.entries(obj)) {
    const currentPath = path ? `${path}.${key}` : key;
    if (key === keyToFind) {
      return currentPath;
    } else if (value !== null && typeof value === 'object') {
      const result = findPropertyPath(value, keyToFind, currentPath);
      if (result) return result;
    }
  }
  return null;
}

const validatePassword = (updatedUiSchema, errors) => {
  const isPasswordValid = store.getState().formData.isPasswordValid;
  const passwordPropertyPath = findPropertyPath(updatedUiSchema, 'password');
  const rePasswordPropertyPath = findPropertyPath(updatedUiSchema, 'rePassword');

  const password = decrypt(store.getState().formData.password) || "";
  const rePassword = decrypt(store.getState().formData.rePassword) || "";
  const passwordsMatch = rePassword === password;
  const passwordError = errors.some(({ property }) => property.includes('password'));

  if (!passwordsMatch && rePassword.length > 0) {
    setNestedProperty(updatedUiSchema, rePasswordPropertyPath, {
      'classNames': 'has-error',
      'ui:errorName': "NoMatch",
    });
    scrollToElement('.has-error');
  }

  if (!isPasswordValid && !passwordError) {
    setNestedProperty(updatedUiSchema, passwordPropertyPath, {
      'classNames': 'has-error',
      'ui:errorName': "password",
    });
    scrollToElement('.has-error');
  }

  return passwordsMatch && isPasswordValid;
};

const findAndEncryptPassword = async (obj, parent = null, key = null) => {
  for (const [k, v] of Object.entries(obj)) {
    if (v !== null && typeof v === 'object') {
      await findAndEncryptPassword(v, obj, k);
    } else if (k === 'password') {
      const encryptedPassword = await getEncryptedValue(v);
      if (parent && key) {
        parent[key].password = encryptedPassword;
        delete parent[key].rePassword;
      } else {
        obj.password = encryptedPassword;
        delete obj.rePassword;
      }
    }
  }
};

const submitForm = async (formData) => {
  const {
    formSubmitEndpointPath,
    formLocale,
    formId,
    successRedirect,
    errorRedirect
  } = store.getState().myPuratos_account.signUpModel;

  const clonedFormData = JSON.parse(JSON.stringify(formData));

  await findAndEncryptPassword(clonedFormData);

  const rawPassword = getNestedProperty(formData, findPropertyPath(formData,'password'));
  const encryptedPassword = getNestedProperty(clonedFormData, findPropertyPath(clonedFormData,'password'));

  if (rawPassword === encryptedPassword) {
    return false;
  }

  try {
    const response = await fetch(`${formSubmitEndpointPath}?locale=${formLocale}&formId=${formId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(clonedFormData),
    });

    if (response.ok) {
      window.location.href = successRedirect;
      return true;
    } else {
      window.location.href = errorRedirect;
      console.error('Form submission failed');
      return false;
    }
  } catch (error) {
    window.location.href = errorRedirect;
    console.error(error);
    return false;
  }
};

export const validateStepData = async ({
                                         formRef,
                                         setFormData,
                                         activeStep,
                                         setActiveStep,
                                         setUiSchema,
                                         validatedData,
                                         setValidatedData,
                                         form,
                                         currentStep,
                                         setIsKnownEmail,
                                         setIsValidating
                                       }) => {
  setIsValidating(true);
  let modifySchema = true;
  const numberOfSteps = form.length;
  const { UiSchema, Schema, isPasswordStep, fieldsForApiValidation } = {
    UiSchema: { ...currentStep.UISchema },
    Schema: currentStep.Schema,
    isPasswordStep: !!currentStep.PasswordChecklist,
    fieldsForApiValidation: currentStep.fieldsForApiValidation || [],
  };
  const isLastStep = activeStep + 1 === numberOfSteps;
  const flow = store.getState().myPuratos_account.signUpModel.flow;
  const { i18n } = store.getState().myPuratos_i18n;
  const formData = formRef.state.formData;
  const password = decrypt(store.getState().formData.password) || "";
  const rePassword = decrypt(store.getState().formData.rePassword) || "";
  const dataToValidate = isPasswordStep ? { ...formData, password, rePassword } : formData;
  const { errors } = formRef.validate(filterFalsyValues(dataToValidate));
  let isExternalValidationOk = false;
  let ga4resultSuccess = 'failed';
  let isPasswordValid = !isPasswordStep;
  const updatedUiSchema = JSON.parse(JSON.stringify(UiSchema));

  setFormData(formData);

  isExternalValidationOk = await validateWithAPI({
    validatedData,
    setValidatedData,
    Schema,
    formData,
    errors,
    updatedUiSchema,
    fieldsForApiValidation
  });

  if (errors.length > 0) {
    errors.forEach(({ property, name }) => {
      setNestedProperty(updatedUiSchema, property, {
        'classNames': 'has-error',
        'ui:errorName': name,
      });
    });
  }

  if (flow === "existing-customer" && activeStep === 0 && isExternalValidationOk && errors.length === 0) {
    const isKnownEmail = await complexValidateWithApi(formData, fieldsForApiValidation);
    setIsKnownEmail(isKnownEmail);
  }

  if (isPasswordStep) {
    isPasswordValid = validatePassword(updatedUiSchema, errors);
  }
  setIsValidating(false);

  const isSafeToProceed = errors.length === 0 && isExternalValidationOk && isPasswordValid;

  const proceed = async () => {
    if (!isLastStep) {
      setActiveStep(activeStep + 1);
      scrollToElement('.steps');
      modifySchema = false;
      return;
    }

    setIsValidating(true);
    const submitted = await submitForm(formData, updatedUiSchema);

    if (!submitted) {
      setNestedProperty(updatedUiSchema, 'password', {
        'classNames': 'has-error',
        'ui:apiError': translate(i18n, 'General error') || 'General error',
      });
      setIsValidating(false);
      ga4resultSuccess = 'failed';
      console.error('Password encryption API failed');
    }
  }

  if (isSafeToProceed) {
    ga4resultSuccess = 'success';

    await proceed();
  } else {
    scrollToElement('.has-error');
  }

  if (modifySchema) {
    setUiSchema(updatedUiSchema);
  }

  googleEvents.submitSignUpStep({
    email_address: formData.Email || "",
    result: ga4resultSuccess,
    customer_type: flow || "",
    step: isLastStep ? 'final' : `${activeStep + 1}`,
  });
}

export const getPostalCode = (postalCode) => {
  if (!postalCode) {
    return null
  }

  const postalCodeArray = postalCode.split(',').map(code => code.trim())
  return postalCodeArray[0]
}

const createNestedAddress = (properties, addressObj, currentForm) => {
  const nestedAddress = {
    ...(addressObj?.box && { box: addressObj.box }),
    ...(addressObj?.city && { city: addressObj.city }),
    ...(addressObj?.streetNumber && { number: addressObj.streetNumber }),
    ...(getPostalCode(addressObj?.postalCode) && { postalCode: getPostalCode(addressObj.postalCode) }),
    ...(addressObj?.streetName && { street: addressObj.streetName }),
    ...(addressObj?.state && { state: addressObj.state }),
  };

  const persistGroup = valuesToPersist(currentForm, properties)
  return properties.reverse().reduce((acc, prop, index) => {
    if (index === 0) {
      return {
        ...persistGroup,
        [prop.replace(/Manual/g, '').trim()]: addressObj.label || '',
        [prop]: nestedAddress
      };
    } else {
      return {
        [prop]: acc
      };
    }
  }, {});
};

export const updateAddressData = (properties, addressObj, setFormData, myFormCurrentState) => {
  if (properties.length === 0) {
    throw new Error("Invalid properties array for address object.");
  }

  const nestedAddress = createNestedAddress(properties, addressObj, myFormCurrentState);
  setFormData(() => (filterFalsyValues({
    ...myFormCurrentState,
    ...nestedAddress
  })));
};

const valuesToPersist = (obj, keys) => {
  let currentObj = { ...obj }
  if (keys.length < 2)
    return {}

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i].trim()
    if (key.toLowerCase().includes('manual')) {
      return currentObj
    }
    currentObj = currentObj[key];
  }
}
